
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { Cart } from "@/types/Cart";
import { CartItem, CartItemCode } from "@/types/cart-item";
import Loader from "@/components/Loader.vue";
import StatusComponent from "@/components/StatusComponent.vue";
const { State } = namespace("Root");

@Component({
  components: {
    Loader,
    StatusComponent,
  },
})
export default class CheckoutPersonalInfo extends Vue {
  @State("cart") cart!: Cart;
  @Prop() item!: CartItem;
  @Prop() submitted!: boolean;
  @Prop() index!: number;

  loading = false;
  error_list: string[] = [];
  /**
   * Gets status component
   */
  status() {
    return this.$refs.status as any;
  }

  mounted() {
    this.onValidated(this.validated);
    switch (this.item.code) {
      case CartItemCode.iphone.code:
      case CartItemCode.applewatch.code:
      case CartItemCode.ipad.code:
        this.item.manufacturer = "Apple";
    }
  }

  onItemChanged(method: string = "") {
    // eslint-disable-next-line no-console
    console.log("changed ", method);
    this.cart.quoteId = -1;
    this.cart.saved = false;
    this.cart.persist();
  }

  /**
   * Get the item name, with or without index, of more items of the same type.
   */
  get itemName() {
    if (this.cart.countByCode(this.item.code) == 1) {
      return (this.item.name + " " + this.item.model).trim();
    } else {
      if (this.item.model != "") {
        return this.item.name + " " + this.item.model;
      } else {
        return (
          this.item.name +
          " " +
          this.cart.indexOfCode(this.item.code, this.item.id)
        );
      }
    }
  }

  /**
   * Get the index of this item from possible
   * other items of specified type.
   */
  // get indexOfCode() {
  //   return this.cart.indexOfCode(this.item.code, this.item.id);
  // }

  /**
   * Is this the first CartItem in the list.
   */
  // get isFirst() {
  //   return this.cart.items.indexOf(this.item) == 0;
  // }

  get validated() {
    let validated =
      this.item.manufacturer != "" &&
      this.item.model != "" &&
      this.item.serial_number != "";
    if (this.item.customer.different_user) {
      validated =
        validated &&
        this.item.customer.first_name != "" &&
        this.item.customer.last_name != "";
    }
    return validated;
  }

  @Watch("validated", { deep: true })
  onValidated(newValue: any) {
    this.$emit("validated", this.item.id, newValue);
  }

  differentUserChanged() {
    this.onValidated(this.validated);
  }
  serialNumberPage() {
    this.$router.push({
      name: "serial.number",
      params: { dest: "wizard.two" },
    });
  }

  showValidationError(field: string) {
    return !field && this.submitted;
  }

  /**
   * Show what is covered info modal.
   */
  showWhatsCovered() {
    this.$router.push({
      name: `compare.${this.item.code}`,
      params: { dest: "wizard.three" },
    });
  }
}
